import React from "react";
import { Button, Paper, TextField, MenuItem, Grid } from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
import { Field, Formik, useFormik } from "formik";
import * as Yup from "yup";
import {
  EDITAR_BANCO,
  LISTAR_BANCOS,
  DETALLE_BANCO,
} from "../../../../graphql/bancos";
const FrmEditarBanco = ({
  setOpenDialog,
  setOpenSnackBar,
  setErrorGraph,
  id,
}) => {
  const {
    data: dbanco,
    loading: lbanco,
    error: ebanco,
  } = useQuery(DETALLE_BANCO, {
    variables: { id: id },
  });

  const [editarBanco] = useMutation(EDITAR_BANCO, {
    update(cache, { data: { editarBanco } }) {
      const { obtenerListaBancos } = cache.readQuery({
        query: LISTAR_BANCOS,
      });
      cache.writeQuery({
        query: LISTAR_BANCOS,
        data: {
          obtenerListaBancos: [...obtenerListaBancos, editarBanco],
        },
      });
    },
  });

  if (lbanco) return <h1>Obteniendo información....</h1>;

  const { obtenerDetalleBanco } = dbanco;

  const handleOpenDialog = () => {
    setOpenDialog(false);
  };

  const onSubmit = async (values, formikValues) => {
    try {
      const dataInput = await editarBanco({
        variables: {
          input: {
            id: values.id,
            banco: values.banco,
            nocuenta: values.nocuenta,
            clabe: values.clabe,
          },
        },
      });
      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: dataInput.data.editarPersona,
        severity: "success",
      });
      setOpenDialog(false);
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          id: obtenerDetalleBanco.id,
          banco: obtenerDetalleBanco.banco,
          nocuenta: obtenerDetalleBanco.nocuenta,
          clabe: obtenerDetalleBanco.clabe,
        }}
        onSubmit={onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          handleChange,
          handleBlur,
          handleReset,
          isSubmitting,
        }) => (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <Paper style={{ padding: 10 }}>
              <Grid container alignItems="flex-start" spacing={3}>
                <Grid item xs={12}>
                  <Field name="banco">
                    {({
                      field, // { name, value, onChange, onBlur }
                      form: { touched, errors },
                      meta,
                    }) => (
                      <TextField
                        {...field}
                        label="Banco"
                        variant="standard"
                        fullWidth
                      />
                    )}
                  </Field>
                </Grid>
                <Grid item xs={12}>
                  <Field name="nocuenta">
                    {({
                      field, // { name, value, onChange, onBlur }
                      form: { touched, errors },
                      meta,
                    }) => (
                      <TextField
                        {...field}
                        label="No. de Cuenta"
                        variant="standard"
                        fullWidth
                      />
                    )}
                  </Field>
                </Grid>
                <Grid item xs={12}>
                  <Field name="clabe">
                    {({
                      field, // { name, value, onChange, onBlur }
                      form: { touched, errors },
                      meta,
                    }) => (
                      <TextField
                        {...field}
                        label="CLABE"
                        variant="standard"
                        fullWidth
                      />
                    )}
                  </Field>
                </Grid>
              </Grid>
            </Paper>
            <Button type="submit">Guardar</Button>
            <Button onClick={() => handleOpenDialog()}>Cerrar</Button>
          </form>
        )}
      </Formik>
    </>
  );
};

export default FrmEditarBanco;
